// extracted by mini-css-extract-plugin
export default {"cardwidth":"About_cardwidth__Hg7v3","rowheight":"About_rowheight__o57fJ"};